import React, { useState } from "react";
import "./Select_reason_heading.css";
import Cancle_Reason_Modal from "../../Common_modal/Cancle_Reason_Modal/Cancle_Reason_Modal";
import { text } from "@fortawesome/fontawesome-svg-core";

function Select_reason_heading({
  reason,
  setReasonId,
  ReasonId,
  setSelectedReason,
  selectedReason,
  text
}) {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <section
        className="Select_reason_heading"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <h6>Select a reason for {text} {">"} {selectedReason?.name}</h6>
      </section>

      <Cancle_Reason_Modal
        setReasonId={setReasonId}
        ReasonId={ReasonId}
        setSelectedReason={setSelectedReason}
        selectedReason={selectedReason}
        reason={reason}
        modal_title={`Select a reason for ${text}`}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </>
  );
}

export default Select_reason_heading;
